import { html, render } from 'lit';
import { virtual } from 'haunted';
import { ButtonColorScheme } from '@outbook/webcomponents-button-color-scheme';

const AmbientToggle = virtual(() => {
  return html`
    <div class="flex items-center">
      ${ButtonColorScheme({
        extraClasses: 'w-6 h-6 s:w-8 s:h-8'
      })}
    </div>
  `;
});

export function ManageAmbient() {
  render(AmbientToggle(), document.getElementById('manage-ambient'));
}
